import * as moment from 'moment';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
} from '@angular/core';

import { Monthpicker } from 'src/app/core/entities/monthpicker.entity';

@Component({
  selector: 'app-monthpicker',
  templateUrl: './monthpicker.component.html',
  styleUrls: ['./monthpicker.component.css'],
})
export class MonthpickerComponent implements OnInit {
  @Input() year: number;
  @Input() month: number;
  @Input() enabledMonths: number[] = [];
  @Input() disabledMonths: number[] = [];
  @Input() enabledYears: number[] = [];
  @Input() disabledYears: number[] = [];
  @Output() selected: EventEmitter<{ monthIndex: number; year: number }> =
    new EventEmitter();

  public model: Monthpicker;
  public isShowYears: boolean;
  public years: Array<number> = [];

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  ngOnInit() {
    if (window.location.pathname.includes('en/')) {
      moment.locale('en');
    } else {
      moment.locale('fr');
    }

    this.model = new Monthpicker();

    // Set year
    this.year = this.year ?? moment().year();
    this.model.selectedYearMoment = moment().year(this.year);
    this.model.selectedMonthYear = this.year;
    this.model.updateYearText();

    // Set month
    this.month = this.month ?? moment().month();
    this.model.selectedMonthIndex = this.month;
    this.model.selectedMonthMoment = moment().month(this.month);

    this.onChange(this.model.selectedMonthIndex, this.model.selectedMonthYear);
  }

  /**
   * Decrements current year
   */
  decrement(): void {
    this.model.decrementYear();
    if (this.isShowYears) {
      this.renderYears();
    }
  }

  /**
   * Increments current year
   */
  increment(): void {
    this.model.incrementYear();
    if (this.isShowYears) {
      this.renderYears();
    }
  }

  /**
   * Selects month
   * @param index new month index
   */
  selectMonth(index: number): void {
    this.model.selectMonth(index);
    this.onChange(this.model.selectedMonthIndex, this.model.selectedMonthYear);
  }

  /**
   * Is selected month
   * @param monthIndex month index
   * @returns boolean
   */
  isSelectedMonth(monthIndex: number): boolean {
    return (
      this.model.selectedMonthIndex == monthIndex &&
      this.model.selectedMonthYear == this.model.selectedYearMoment.year()
    );
  }

  /**
   * On change month
   * @param monthIndex month index
   * @param year current year
   */
  onChange(monthIndex: number, year: number): void {
    this.selected.emit({ monthIndex: monthIndex, year: year });
  }

  /**
   * Is disabled month
   * @param index month index
   * @returns boolean
   */
  isDisabled(index: number): boolean {
    let disabled = false;
    if (this.enabledMonths && this.enabledMonths.length > 0) {
      disabled = this.enabledMonths.indexOf(index) < 0;
    }
    if (this.disabledMonths && this.disabledMonths.length > 0) {
      disabled = this.disabledMonths.indexOf(index) >= 0;
    }
    return disabled;
  }

  /**
   * Toggles show years panel
   */
  toggleShowYears(): void {
    this.isShowYears = !this.isShowYears;
    this.renderYears();
  }

  /**
   * Renders years
   */
  renderYears(): void {
    this.years = [];
    for (let i = 5; i > 0; i--) {
      this.years.push(this.model.selectedYearMoment.year() - i);
    }
    for (let i = 0; i <= 6; i++) {
      this.years.push(this.model.selectedYearMoment.year() + i);
    }
  }

  /**
   * Selects year
   * @param year year index
   */
  selectYear(year: number): void {
    this.isShowYears = false;
    this.model.selectedYearMoment = moment().year(year);
    this.model.updateYearText(); // in set get aendern
  }

  /**
   * Is selected year
   * @param year year index
   * @returns boolean
   */
  isSelectedYear(year: number): boolean {
    return this.model.selectedYearMoment.year() === year;
  }

  /**
   * Is disabled year
   * @param year year index
   * @returns boolean
   */
  isDisabledYear(year: number): boolean {
    let disabled = false;
    if (this.enabledYears && this.enabledYears.length > 0) {
      disabled = this.enabledYears.findIndex((y) => y === year) < 0;
    }
    if (this.disabledYears && this.disabledYears.length > 0) {
      disabled = this.disabledYears.findIndex((y) => y === year) >= 0;
    }
    return disabled;
  }
}
